import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  PropTypes
} from 'prop-types';

import {
  ColorSvg,
  HContainer,
  Text,
  VContainer,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  CustomColors,
  Icons
} from '../../../constants';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

const CityContainer = styled(HContainer)`
  border-bottom: 1px solid ${CustomColors.Grey5};
`;

const CitySelectorUI = props => {

  const [
    state,
    setState
  ] = React.useState({
    selectedCity: props.selectedCity
  });

  const createCityList = () => {

    let cityList = [];

    if (!Array.isArray(props.cities)) {
      return cityList;
    }

    for (const city of props.cities) {

      cityList.push(

        <CityContainer
          padding={'0 19px 0 15px'}
          height={'50px'}
          alignItems={'center'}
          key={`city-${city.name}`}
          onClick={() => {

            setState(prevState => ({
              ...prevState,
              selectedCity: city.name
            }));
          }}>

          <Text
            fontSize={'18px'}
            color={CustomColors.Grey11}>

            {city.name}
          </Text>

          {city.name === state.selectedCity &&

            <ColorSvg
              src={Icons.CheckmarkThin}
              color={CustomColors.Green5}
              height={'33px'}
              width={'33px'}
              margin={'0 0 0 auto'} />
          }

        </CityContainer>
      );
    }
    return cityList;
  };

  return (

    <VFillContainer
      height={'100%'}
      backgroundColor={CustomColors.White}>

      <CityContainer
        padding={'16px'}
        justifyContent={'center'}>

        <Text
          fontSize={'20px'}
          fontWeight={'bold'}
          color={CustomColors.Grey11}>

          {'Choose City'}
        </Text>

      </CityContainer>

      <VContainer>

        {createCityList()}

      </VContainer>

      <VContainerVH
        margin={'32px 0'}>

        <PrimaryButton
          text={'OK'}
          margin={'0 0 16px'}
          onClick={() => props?.onOkClick?.(state.selectedCity)}/>

        <SecondaryButton
          text={'Cancel'}
          onClick={props?.onCancelClick}/>

      </VContainerVH>

    </VFillContainer>
  );
};

CitySelectorUI.propTypes = {
  cities: PropTypes.array,
  selectedCity: PropTypes.string,
  onCancelClick: PropTypes.func,
  onOkClick: PropTypes.func
};

CitySelectorUI.defaultProps = {
  cities: Environment?.current?.cities,
  selectedCity: Environment?.current?.cities?.[3].name,
  onCancelClick: () => {},
  onOkClick: () => {}
};

CitySelectorUI.page_name = 'cbu: connectu: detailed weather: choose a city';

CitySelectorUI.tagViewData = {
  page_section: 'detailed weather'
};

export const CitySelector = withScreenViewTagging(CitySelectorUI);